export default __webpack_public_path__ + "static/media/user.0c1efd82.jpg";